import { styled } from '@mui/material/styles'

const B = styled('path')({})

export default B
